import React from 'react'
import { connect } from 'react-redux'
import * as F from 'discada/dist/Form'

import {
  getConfigMakes,
  getConfigModelsForMake,
  getConfigTrimsForModel,
  createConfig,
  clearCloneConfigFormData,
} from 'actions/appStatusActions'

import {
  getConfigVehicleValues,
  getMatchingExisitngConfig,
} from 'selectors/appStatusSelectors'

import './AddConfigForm.scss'

export class AddConfigForm extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      make: null,
      model: null,
      trim: null,
      year: null,
      condition: null,
    }

    this.g = {
      make: () => this.props.getConfigModelsForMake(this.state.make),
      model: () => this.props.getConfigTrimsForModel(this.state.model),
      trim: () => {},
      year: () => {},
      condition: () => {},
    }

    this.setVal = key => ({ target }) =>
      this.setState({ [key]: target.value || null }, this.g[key])
  }

  componentDidMount() {
    setTimeout(this.props.getConfigMakes, 1)
  }

  componentWillUnmount() {
    this.props.clearCloneConfigFormData()
  }

  render() {
    let {
        createConfig,
        onCancel,
        makes,
        models,
        trims,
        doesConfigExist,
        cloneId,
      } = this.props,
      { make, model, trim, year, condition } = this.state,
      yearStart = new Date().getFullYear() + 2, //2 years in the future
      yearOptions = [...Array(50)].map((_, i) => {
        let val = yearStart - i

        return (
          <option key={val} value={val}>
            {val}
          </option>
        )
      }),
      makeOptions = collection =>
        collection.map(c => (
          <option value={c} key={c}>
            {c}
          </option>
        )),
      configAlreadyExists = doesConfigExist(this.state)

    return (
      <div className="add-config-form">
        {cloneId ? <h3>Clone config</h3> : <h3>Add new config</h3>}

        <F.Field className="config-select-group">
          {fieldProps => (
            <React.Fragment>
              <div className="field">
                <F.SimpleSelectField
                  {...fieldProps}
                  value={condition}
                  onChange={this.setVal('condition')}
                >
                  <option value="">All Types</option>
                  <option value="new">New</option>
                  <option value="used">Used</option>
                </F.SimpleSelectField>
              </div>
              <div className="field">
                <F.SimpleSelectField
                  {...fieldProps}
                  value={year}
                  onChange={this.setVal('year')}
                >
                  <option value="">All Years</option>
                  {yearOptions}
                </F.SimpleSelectField>
              </div>
              <div className="field">
                <F.SimpleSelectField
                  {...fieldProps}
                  value={make}
                  onChange={this.setVal('make')}
                >
                  <option value="">All Makes</option>
                  {makeOptions(makes)}
                </F.SimpleSelectField>
              </div>
              <div className="field">
                <F.SimpleSelectField
                  {...fieldProps}
                  onChange={this.setVal('model')}
                  value={model}
                  disabled={!models.length}
                >
                  <option value="">All Models</option>
                  {makeOptions(models)}
                </F.SimpleSelectField>
              </div>
              <div className="field">
                <F.SimpleSelectField
                  {...fieldProps}
                  onChange={this.setVal('trim')}
                  value={trim}
                  disabled={!trims.length}
                >
                  <option value="">All Trims</option>
                  {makeOptions(trims)}
                </F.SimpleSelectField>
              </div>
            </React.Fragment>
          )}
        </F.Field>

        {configAlreadyExists && (
          <article className="message is-warning is-small">
            <div className="message-body">
              Settings for the selected attributes these options already exist.
              If you continue, those settings will be overwritten with these new
              settings.
            </div>
          </article>
        )}

        <F.Controls
          saveLabel="Create Config"
          onSave={() => createConfig('quote', this.state, cloneId)}
          onCancel={onCancel}
        />
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  return {
    ...op,
    makes: getConfigVehicleValues(state, 'makes').sort(),
    models: getConfigVehicleValues(state, 'models').sort(),
    trims: getConfigVehicleValues(state, 'trims').sort(),
    doesConfigExist: ids => getMatchingExisitngConfig(state, ids),
  }
}

export default connect(
  mapStateToProps,
  {
    getConfigMakes,
    getConfigModelsForMake,
    getConfigTrimsForModel,
    createConfig,
    clearCloneConfigFormData,
  },
)(AddConfigForm)
